/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { useEffect, useState } from "react";
import { useToast } from "../../../context/toast-context";
import useAPIHandler from "../../../hook/use-api-handler";
import {
  getErrorDetailsFn,
  getInputFieldProps,
  safeToString,
} from "../../../utils/common";
import { logger } from "../../../utils/logger";
import {
  PTAX_API,
  PTAX_INITIAL_STATE,
  TAX_INPUT_FIELDS,
} from "./ptax-constant";
import { ptaxValidationSchema } from "./ptax-validation";

const usePTaxService = () => {
  const [esiInputs, setesiInputs] = useState(
    structuredClone(PTAX_INITIAL_STATE)
  );

  const { showToastMessage } = useToast();

  const [pTaxListInfo, setPTaxListInfo] = useState({
    ptaxList: [],
    ptaxYearList: [],
  });
  const [pTaxInfo, setPTaxInfo] = useState({});

  const { fetchData } = useAPIHandler();
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const [setOpenPtaxModal, setOpenStatutoryPTAXModal] = useState(false);

  const handleOpenStatutoryPtaxModal = () => setOpenStatutoryPTAXModal(true);
  const handleCloseStatutoryPtaxModal = () => setOpenStatutoryPTAXModal(false);

  const handleChangeFunction = (e, name) => {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      TAX_INPUT_FIELDS[name].customOptions &&
      TAX_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = TAX_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        esiInputs
      );
    }
    if (name === "state") {
      setPTaxListInfo({
        ...pTaxListInfo,
        ptaxYearList: [],
      });

      setPTaxInfo({});
    }

    setesiInputs((prevUser) => ({
      ...prevUser,
      [name]: value,
      ...(name === "state" && { financial_year: "" }),
    }));

    const fieldSchema = ptaxValidationSchema.extract(name);
    const { error } = fieldSchema.validate(value, {});

    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = ptaxValidationSchema.extract(name);
    const { error } = fieldSchema.validate(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }

  const handleSubmitFn = async () => {
    const { status, ptax_ec_code, ptax_rc_code, financial_year, state } =
      esiInputs;

    const payload = {
      data: {
        ptax_ec_code,
        ptax_rc_code,
        financial_year,
        state,
        status,
      },
      ...PTAX_API.PTAX_CREATE,
    };

    let error = {};

    if (status) {
      error = ptaxValidationSchema.validate(
        {
          status,
          ptax_ec_code,
          ptax_rc_code,
          state,
          financial_year,
        },
        {
          abortEarly: false,
        }
      )?.error;
    } else {
      payload.data = {
        status: false,
        ptax_ec_code: "",
        ptax_rc_code: "",
        financial_year: "",
        state: "",
      };
    }

    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      // if (pTaxInfo?.ptax_id) {
        try {
          setCreateUpdateLoading(true);
          const responseData = await fetchData(payload);
          handleCloseStatutoryPtaxModal();
          if (!responseData?.statusCode) {
            setesiInputs(responseData?.data);
          }

          showToastMessage({
            message: `PTAX ${responseData?.statusCode ? "Update" : "Added"} succesfully!`,
            color: "success",
          });

          // getPatxFn()
        } catch (error) {
          setCreateUpdateLoading(false);
          const { message, errorObj } = getErrorDetailsFn(error);

          showToastMessage({
            message,
            color: "danger",
          });
          setErrors(errorObj);
        } finally {
          setCreateUpdateLoading(false);
        }
      // } else {
      //   showToastMessage({
      //     message: `Please choose Valid State And Financial Year`,
      //     color: "danger",
      //   });
      // }
    }
  };

  function handleDisableAllPTaxFn() {
    if (!esiInputs.status) {
      setesiInputs({ ...structuredClone(PTAX_INITIAL_STATE), status: true });
    } else {
      setErrors({});
      setesiInputs((prev) => ({
        ...structuredClone(PTAX_INITIAL_STATE),
        status: false,
      }));
      setPTaxInfo({});
    }
  }

  function handleDisableAllPTaxFnMOdal() {

    if (esiInputs?.status) {
      setPTaxInfo({});
      setErrors({});
      setesiInputs({
        status: false,
        financial_year: null,
        org_id: null,
        org_ptax_id: esiInputs?.org_ptax_id,
        ptax_ec_code: "",
        ptax_rc_code: "",
        state: null,
      });
    }
    else{
      setesiInputs({...esiInputs,status:true})
    }
  }
 
  const [stateList, setStateList] = useState([]);
  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      TAX_INPUT_FIELDS[fieldName] || {};

    // let disabled = !!restProps.disabled;
    // if (!esiInputs.status) {
    //   disabled = true;
    // }

    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: esiInputs,
        type: restProps.type || "text",
        error,
        handleChangeFunction,
        handleBlurFn,
      }),
    };

    return props;
  };

  function getPatxFn() {
    const payload1 = {
      url: "/common/state",
      METHOD: "GET",
    };

    fetchData(payload1).then((res) => {
      const temp = res?.data?.map((ele) => {
        return { id: ele?.state_id, name: ele?.state_name };
      });
      setStateList(temp);
      getPtaxtGetInfo();
    });
  }

  const getFinancialYears = async (id) => {
    const payload = {
      url: `/admin/p-tax?state_id =${id}`,
      METHOD: "GET",
    };
    fetchData(payload).then((res) => {
      if (res) {
        const yearList = res?.data?.map((ele) => {
          return { id: ele?.ptax_id, name: `${ele?.year}-${ele?.to_year}` };
        });

        setPTaxListInfo({
          ...pTaxListInfo,
          ptaxYearList: yearList,
          allInfo: res?.data,
        });
      }
    });
  };
  const setFinancialInfo = (e) => {
    const taxList = pTaxListInfo?.allInfo?.filter((ele) => {
      if (ele?.ptax_id === e) {
        return ele?.tax_cal;
      }
    });
    if (taxList?.length > 0) {
      setPTaxInfo(taxList[0]);
    }
  };

  const getPtaxtGetInfo = async () => {
    const payload = {
      url: "organization/org-ptax",
      METHOD: "GET",
    };
    fetchData(payload)
      .then((res) => {
        if (res) {
          setesiInputs(res?.data);

          getFinancialYears(res?.data?.state);
        }
      })
      .catch((e) => {
        logger.log(e);
      });
  };
  useEffect(() => {
    getPatxFn();
  }, []);

  useEffect(() => {
    getFinancialYears(esiInputs?.state);
  }, [esiInputs?.state]);

  useEffect(() => {
    setFinancialInfo(esiInputs?.financial_year);
  }, [esiInputs?.financial_year]);

  logger.log(esiInputs,"p-tax-inputs")

  return {
    esiInputs,
    setesiInputs,
    getInputFieldPropsFn,
    handleDisableAllPTaxFn,
    handleSubmitFn,
    createUpdateLoading,
    stateList,
    pTaxListInfo,
    pTaxInfo,
    setPTaxInfo,
    setOpenPtaxModal,
    handleOpenStatutoryPtaxModal,
    handleCloseStatutoryPtaxModal,
    handleDisableAllPTaxFnMOdal,
  };
};

export default usePTaxService;
